import { request } from '../request';
/**
 * Login
 *
 * @param userName User name
 * @param password Password
 */
export function fetchLogin(account: string, password: string, appUuid: string, channel: string) {
  return request<Api.Auth.LoginBack>({
    url: '/developer-platform/api/user/login',
    method: 'post',
    params: {
      account,
      password,
      appUuid,
      channel
    }
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: '/auth/getUserInfo' });
}

/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/refreshToken',
    method: 'post',
    data: {
      refreshToken
    }
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}

/**
 * 获取验证码
 *
 * @param email
 */
export function fetchGetEmailToken(params?: Api.Auth.emailToken) {
  return request<string>({
    url: '/usercenter/api/uc/otp/request/email',
    method: 'post',
    params
  });
}

/**
 * 验证验证码
 *
 * @param receiver
 * @param code
 * @param token
 */
export function fetchGetVerifyToken(params?: Api.Auth.verifyToken) {
  return request<number>({
    url: '/usercenter/api/uc/profile/v2/verify/code',
    method: 'post',
    params
  });
}

/**
 * 重置密码
 *
 * @param email
 * @param code
 * @param token
 * @param newPassword
 */
export function fetchResetPassword(params?: Api.Auth.resetPwd) {
  return request<boolean>({
    url: '/usercenter/api/uc/profile/password/email/otp',
    method: 'post',
    params
  });
}

/** 退出登录 */
export function fetchLoginOut() {
  return request({
    url: '/usercenter/api/uc/logout',
    method: 'get'
  });
}

/**
 * 获取系统名称，logo等信息
 *
 * @param domainName
 */
export function fetchPostSystemInfo(params?: Api.Auth.Domain) {
  return request<Api.Auth.systemInfo>({
    url: '/developer-platform/api/openapi/systemInfo',
    method: 'get',
    params
  });
}

export function fetchSetLanguage(data) {
  return request({
    url: '/developer-platform/api/user/language/set',
    method: 'post',
    data
  });
}
